import { buildDays } from '../utils/dates';

// Granularité de la frise : largeur de colonne (1 colonne = 1 jour), étendue de la fenêtre, pas de navigation
const ZOOM_CFG = {
  jour: { COL: 62, days: 70, step: 7 },
  semaine: { COL: 26, days: 154, step: 28 },
  mois: { COL: 14, days: 266, step: 90 },
};

/* Valeurs dérivées de l'état, partagées par toutes les vues. */
export function deriveViewState({ appState, profile, viewAsMemberId, timelineZoom }) {
  // Devs visibles dans les listes/sélecteurs (les archivés restent dans st.devs
  // pour les calculs de coût et l'affichage des noms, mais sont masqués ici).
  const activeDevs = (appState.devs || []).filter((d) => !d.archived && d.isPlanifiable !== false);
  // Équipe (membres/congés/historique) : "planifiable" ne concerne que la Timeline/les
  // affectations projet — un membre non planifiable (ex : Sandra, Guillaume) reste un membre de
  // l'équipe à part entière et doit apparaître dans la liste, poser des congés, etc.
  const teamDevs = (appState.devs || []).filter((d) => !d.archived);
  const { COL, days: TL_DAYS, step: NAV_STEP } = ZOOM_CFG[timelineZoom] || ZOOM_CFG.jour;
  const days = buildDays(new Date(appState.tlStart), TL_DAYS);

  // "Voir en tant que" (manager) : aperçu lecture seule de l'interface d'un dev précis. realIsManager
  // reste le vrai rôle (contrôle d'accès à la fonctionnalité elle-même, jamais falsifiable) ; isManager
  // est délibérément forcé à false pendant l'aperçu — c'est LE seul flag utilisé partout ailleurs pour
  // choisir la nav/les vues/les actions d'édition, donc le forcer ici bascule tout le reste de l'app en
  // mode dev sans avoir à toucher un par un chaque endroit qui le lit.
  const realIsManager = profile?.role === 'manager';
  const previewMode = !!viewAsMemberId;
  const viewAsDev = previewMode ? (appState.devs || []).find((d) => d.id === viewAsMemberId) : null;
  const isManager = realIsManager && !previewMode;
  return {
    COL,
    NAV_STEP,
    activeDevs,
    days,
    teamDevs,
    isManager,
    previewMode,
    realIsManager,
    viewAsDev,
  };
}
